// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__18zzC","info":"UpdateTermsInfo_info__3Jso8"};